module.exports = __webpack_public_path__ + "static/media/semiconductors_hero_tablet.5941cb41.jpg";